import { axiosMock } from '../client';
import { API_URL } from '../apiDictionary';
import { faker } from '@faker-js/faker';
import { ClinicalTrialAffiliateNames } from '@dynamika-shared/types/clinicalTrialAffiliates';

const createRandomClinicalTrialAffiliate = () => {
  const numberOfContent = faker.number.int({ min: 1, max: 5 });

  const data = Array.from({ length: numberOfContent }, () => {
    const nameCT = Object.values(ClinicalTrialAffiliateNames);
    const randomNumberCT = faker.number.int({
      min: 1,
      max: nameCT.length,
    });
    const randomName = nameCT[randomNumberCT - 1];

    return {
      name: randomName,
      id: faker.string.alphanumeric(10),
      code: faker.lorem.word(),
    };
  });

  return {
    data,
  };
};

export const fetchClinicalTrialAffiliateMock = () => {
  const { data } = createRandomClinicalTrialAffiliate();
  return axiosMock.onGet(API_URL.clinicalTrialAffiliate).reply(200, data);
};
